module.exports = __webpack_public_path__ + "static/media/icono-ticket.fd43d25f.png";